module.exports = __webpack_public_path__ + "static/media/rou_on_high.a97bc8a7.png";